<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-shopping-cart-2 v-bind='{...{},...{}}' :style='""' class="" ></m-shopping-cart-2><m-a v-bind='{...{"href":"https:\/\/mixitweb.com"},...{}}' :style='""' class="d-block text-center text-decoration-none text-dark h4" >
                <template #default>ساخت و توسعه توسط mixitweb.com   </template>
                </m-a>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mShoppingCart2,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
